
//引用公共的组件定义到全局
import Title from "../components/content/title/Title";
import Banner from "../components/content/banner/Banner";
import Country from "../components/content/country/countryList"
import Button from "../components/content/button/Button"

export default (Vue)=>{
    Vue.component('MyTitle',Title)
    Vue.component('MyBanner',Banner)
    Vue.component('MyCountry',Country)
    Vue.component('MyButton',Button)
}